import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { takeFirst } from "~/features/app/utils";
import { isLinkValid } from "~/features/ui/link/utils";
import ArrowRight from "~/public/icons/arrow-right.svg";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
const fragment = graphql(`
  fragment MediaCardsCardLink on blocks_mediaCardsCardLink_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
type PlainLink = Record<string, unknown> & {
  href?: string;
  newWindow?: boolean;
  text?: React.ReactNode;
};
export type MediaCardsCardLinkViewProps = {
  link?: PlainLink | Array<PlainLink | null | undefined> | null;
};
function getPlainLinkIcon(link?: PlainLink | null) {
  if (!link) {
    return undefined;
  }
  return link.newWindow ? ArrowTopRight : ArrowRight;
}
export function MediaCardsCardLinkView({
  link: linkValue
}: MediaCardsCardLinkViewProps) {
  const link = takeFirst(linkValue);
  const icon = getPlainLinkIcon(link);
  if (!isLinkValid(link)) {
    return null;
  }
  return <Button as={Link} {...link} variant="secondary" icon={icon} />;
}
export function MediaCardsCardLink(props: FragmentType<typeof fragment>) {
  const {
    link
  } = useFragment(fragment, props);
  return <MediaCardsCardLinkView link={link as MediaCardsCardLinkViewProps["link"]} />;
}